import * as customersMutations from "@/store/modules/customers/mutation-types";
import * as securityMutations from "@/store/modules/security/mutation-types";
import * as listeners from "./listeners";
import * as helpers from "./helpers";

export default store => {
  store.subscribe(({ type, payload }) => {
    if (!mutationListeners[type]) {
      return;
    }
    mutationListeners[type](store, payload);
  });
};

const mutationListeners = {
  [helpers.customersNamespaced(
    customersMutations.SET_CURRENT_CUSTOMER
  )]: listeners.onCurrentCustomerSet,
  [helpers.customersNamespaced(
    customersMutations.RESET_CURRENT_CUSTOMER
  )]: listeners.onCurrentCustomerReset,
  [helpers.securityNamespaced(
    securityMutations.RESET_CURRENT_USER
  )]: listeners.onCurrentUserReset,
};
